export const readToken = () => localStorage.getItem('idToken');
// Logout must clear localstorage and all token values
export const writeToken = (token) => localStorage.setItem('idToken', token);
export const removeToken = () => localStorage.removeItem('idToken');
export const removeAllToken = () => localStorage.clear();
export const readNetworkSpeedToken = () => localStorage.getItem('networkSpeed');
// Logout must clear localstorage and all token values
export const writeNetworkSpeedToken = (speed) => localStorage.setItem('networkSpeed', speed);
